import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import CareersHero from '../components/careers/CareersHero';
import WhyTraain from '../components/careers/WhyTraain';
import OurValues from '../components/careers/OurValues';
import Benefits from '../components/careers/Benefits';
import OpenRoles from '../components/careers/OpenRoles';
import CareersCTA from '../components/careers/CareersCTA';

const CareersPage = () => {
  return (
    <div className="min-h-screen bg-gray-950">
      <Navbar />
      <CareersHero />
      <WhyTraain />
      <OurValues />
      <Benefits />
      <OpenRoles />
      <CareersCTA />
      <Footer />
    </div>
  );
};

export default CareersPage;